import React from 'react';
import BeachLineFeature from './components/BeachLineFeature/BeachLineFeature';
import BeachSurfaceFeature from './components/BeachSurfaceFeature';
import BeachDistanceFeature from './components/BeachDistanceFeature/BeachDistanceFeature';
import AirportDistanceFeature from './components/AirportDistanceFeature';
import WifiTypeFeature from './components/WifiTypeFeature';
import type { HotelFeatures } from '../../types';

import styles from './hotelCardFeatures.module.css';

type HotelCardFeaturesProps = {
  isMobile: boolean;
  features: HotelFeatures;
};

const HotelCardFeatures = (props: HotelCardFeaturesProps) => {
  const { features, isMobile } = props;
  return (
    <div className={styles.featuresContainer}>
      <BeachLineFeature value={features.beachLine} isMobile={isMobile} />
      <BeachSurfaceFeature value={features.beachSurface} isMobile={isMobile} />
      <BeachDistanceFeature
        value={features.beachDistance}
        isMobile={isMobile}
      />
      <AirportDistanceFeature
        value={features.airportDistance}
        isMobile={isMobile}
      />
      <WifiTypeFeature value={features.wiFi} isMobile={isMobile} />
    </div>
  );
};

export default HotelCardFeatures;
